import { Search, FileText, Download, Handshake } from "lucide-react";
import { useLocale } from "@/i18n/context";

const stepIcons = [Search, FileText, Download, Handshake];

export const HowItWorks = () => {
  const { t } = useLocale();
  return (
    <section id="how-it-works" className="process-section scroll-mt-28">
      <div className="container mx-auto px-5 sm:px-8">
        <div className="section-heading-row">
          <div><p className="editorial-eyebrow">{t.howItWorks.eyebrow}</p><h2 className="section-title mt-4">{t.brand.processTitle}</h2></div>
          <p className="leading-relaxed text-muted-foreground">{t.howItWorks.description}</p>
        </div>
        <ol className="process-steps">
          {t.howItWorks.steps.map((step, index) => {
            const Icon = stepIcons[index];
            return (
              <li key={step.title} className="process-step">
                <div className="process-step-top"><span>{String(index + 1).padStart(2,"0")}</span><Icon className="h-5 w-5" aria-hidden="true" /></div>
                <h3>{step.title}</h3><p>{step.description}</p>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
};
